module.exports = __webpack_public_path__ + "img/helena.66d8af4b.jpg";